import { render, staticRenderFns } from "./TeacherJournal.vue?vue&type=template&id=4b14a5aa&scoped=true&"
import script from "./TeacherJournal.vue?vue&type=script&lang=js&"
export * from "./TeacherJournal.vue?vue&type=script&lang=js&"
import style0 from "./TeacherJournal.vue?vue&type=style&index=0&lang=less&"
import style1 from "./TeacherJournal.vue?vue&type=style&index=1&id=4b14a5aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b14a5aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCombobox,VIcon,VList,VListItem,VListItemTitle,VMenu,VProgressCircular,VSelect,VSwitch,VTextField,VTooltip})
